// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"253":"ad044ea724fb7210","842":"fd4dd3eb924bcb11","954":"3c252ab6a2244965"}[chunkId] + ".css";
};